import { render, staticRenderFns } from "./ResearchMultiAnnotationsPlot.vue?vue&type=template&id=2b761862&"
import script from "./ResearchMultiAnnotationsPlot.vue?vue&type=script&lang=js&"
export * from "./ResearchMultiAnnotationsPlot.vue?vue&type=script&lang=js&"
import style0 from "./ResearchMultiAnnotationsPlot.vue?vue&type=style&index=0&id=2b761862&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b761862')) {
      api.createRecord('2b761862', component.options)
    } else {
      api.reload('2b761862', component.options)
    }
    module.hot.accept("./ResearchMultiAnnotationsPlot.vue?vue&type=template&id=2b761862&", function () {
      api.rerender('2b761862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMultiAnnotationsPlot.vue"
export default component.exports